import axios from 'axios'
import qs from 'qs'
import { MessageBox, Message, Loading } from 'element-ui'

const msg = 'msg' // msg转换值

// create an axios instance
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.post['Content-Type'] = 'application/json'
// http://testapi3.pinnongjt.com/pinnong3/login/loginIn
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: "/api",
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})
// console.log(service)
// console.log(service.defaults)

// code标准
const code = {
  success: {
    value: 200,
    [msg]: 'success'
  }
}

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.method === 'post' && config.data) {
      config.data = qs.stringify(config.data)
    }

    return config
  },
  error => {
    // do something with request error
    console.log('request error:', error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log('response', res.code)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 200 || res.code === 1) {
      return Promise.resolve(res)
    } else {
      return Promise.reject(res)
    }
  },
  error => {
    console.log('response err:', error) // for debug
    // return Promise.reject({
    //   code: 0,
    //   [msg]: '请求失败，请刷新页面重试'
    // })
  }
)

const request = (options, success, error) => {
  options =
    typeof options === 'string'
      ? {
          url: options
        }
      : options
  options.method = options.method || 'post' // 默认请求方式为post

  // 加载动画 ，默认开启
  var loading = typeof options.loading === 'undefined' ? true : options.loading
  var loadingInstance = null
  if (loading) {
    loading =
      typeof loading === 'object'
        ? loading
        : {
            target: '.app-main',
            background: 'rgba(0, 0, 0, 0)'
          }
    loadingInstance = Loading.service(loading)
  }

  return service(options)
    .then(res => {
      loadingInstance && loadingInstance.close()
      // console.log('then:', res)

      var success_result = true
      if (typeof success === 'function') {
        success_result = success(res)
      }

      // 成功回调函数返回值为false时，不再显示信息提示

      if (success_result == 'cancel') {
        return Promise.resolve(res)
      }

      if (success_result) {
        var cur_message = res[msg]
        if (cur_message) {
          Message({
            showClose: true,
            message: cur_message,
            type: 'success',
            duration: 2000
          })
        }
      } else {
        var cur_message = res[msg]
        if (cur_message) {
          Message({
            showClose: true,
            message: cur_message,
            type: 'error',
            duration: 6000
          })
        }
      }
      return Promise.resolve(res)
    })
    .catch(res => {
      loadingInstance && loadingInstance.close()
      console.log('error:', res)
      // 失败回调
      var success_result = true
      if (typeof error === 'function') {
        success_result = error(res)
      }
      // 失败回调函数返回值为false时，不再显示信息提示
      // if (success_result !== false) {
      //   var cur_message = res[msg] || '失败'
      //   MessageBox.alert(cur_message, '错误', {
      //     confirmButtonText: '确定',
      //     type: 'error',
      //     center: true
      //   })
      // }
      return Promise.resolve(res)
    })
}

export default request
